module.exports = __webpack_public_path__ + "img/stellarauth.9203c03f.svg";